<script setup>
import ProcessTemplate from '@/components/templates/ProcessTemplate.vue';

</script>

<template>
  <ProcessTemplate />
</template>

